import React, { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import FileCards from '../../containers/Forms/FileCard';
import { FormControlLabel, Typography, Divider, CircularProgress } from '@mui/material';
import HeightBox from '../../components/HeightBox';
import { createJobOrder,updateJobOrder } from './services';
import {createTheme, ThemeProvider} from '@mui/material/styles';
import { getJobOrdersAction } from './actions'
import CandidateService from '../../services/candidateService';
import { useSelector,useDispatch } from 'react-redux';
import { IconButton } from '@mui/material';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { fieldData } from './createJobOrder';
import FormGenerator from './FormGenerator';
const theme = createTheme({
  typography: {
    fontSize: 10, // Adjust the default font size
  },
  components: {
    // Customize the component sizes
    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: 12, // Adjust the button font size
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          fontSize: 12, // Adjust the text field font size
          height: 30, // Adjust the text field height
          size: "small", // Adjust the text field height
          boxSizing: "inherit", // Adjust the text field height
        },
      },
    },
    // Add other components here with their desired customizations
  },
});

const UpdateJobOrderForm = (props) => {

     // Define the initial state for working days
const initialWorkingDays = {
    sunday: false,
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: false,
  };
    const [workingDays, setWorkingDays] = useState(initialWorkingDays);
    // Create an array with the selected working days
  const workingDaysArray = Object.keys(workingDays).filter(
    (day) => workingDays[day]
  );

  const [loading, setLoading] = useState(false);

  const [jobOrder, setJobOrder] = useState({
    profession: '',
    quantity: '',
    accommodation: false,
    transportation: false,
    medical: false,
    airTicketsJoining: false,
    airTicketsAnnual: false,
    contractPeriod: '',
    probationPeriod: '',
    annualLeave: '',
    medicalLeave: '',
    emergencyLeave: '',
    overtime: false,
    workingHours: '',
    weeklyWorkingHours: '',
    workingDays: '',
    agencyFee: '',
    jobDescription: '',
    workSite: '',
    availabilityPeriod: '',
    nameOfForeignPrincipal: ''
  });

  React.useEffect(() => {
    setJobOrder(props?.jobOrder)
    setRows(props?.jobOrder?.professions)
  }, [props.jobOrder]);

  const dispatch=useDispatch();
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const fieldValue = type === 'checkbox' ? checked : value;

    setJobOrder((prevState) => ({
      ...prevState,
      [name]: fieldValue,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    // Perform form submission logic or API request with jobOrder data
    const jobOrderData = {
      ...jobOrder,
      professions:rows,
    }
    console.log(jobOrderData);
    updateJobOrder(jobOrderData.id,jobOrderData).then((response) => {
      console.log(response);
      setLoading(false);
      dispatch(getJobOrdersAction);
      props.handleClose()
    }).catch((error) => {
      console.log(error);
      setLoading(false);
      props.handleClose()
    });
  };

  const handleOnClose = () => {
    props.handleClose()
  };

    
    const [rows, setRows] = useState([
      {
        serialNumber: '',
        jobCategory: '',
        vacancies: '',
        salary: '',
        currency: '',
      },
    ]);
  
    const handleChangeRows = (index, field, value) => {
      const updatedRows = [...rows];
      updatedRows[index][field] = value;
      setRows(updatedRows);
    };
  
    const addRow = () => {
      setRows([...rows, { serialNumber: '', jobCategory: '', vacancies: '', salary: '', currency: '' }]);
    };
  
    const removeRow = (index) => {
      const updatedRows = [...rows];
      updatedRows.splice(index, 1);
      setRows(updatedRows);
    };

    const [file, setFile] = useState(null);
 
  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const [fileName, setFileName] = useState(null);

  const uploadFile = (file) => {
    //shpw alert to input file name
    const fileName = prompt("Enter file name");
    //remove spaces
    const name = fileName.replace(/\s/g, '');
    //set file name
    const formData = new FormData();
    const extraField = {
      "jobOrderId":jobOrder.id,
    }

    formData.append("file", file);
    formData.append("regNumber", jobOrder.id)
    formData.append("nic", jobOrder.id)
    formData.append("fileName",name)
    formData.append("ent","jobOrder")
    formData.append("extraField",JSON.stringify(extraField))
    
    CandidateService.uploadNewFile(formData).then((res) => {
      alert("File uploaded successfully");
    }).catch((err) => {
      alert("Error uploading file");
    });
  };

  const [files, setFiles] = useState([])

  // useEffect(() => {
  //   getNewFile(jobOrder.id);
  // }, [jobOrder.id]);

  const getNewFile = async (nic) => {
    console.log(nic)
    try {
      const res = await CandidateService.getNewFiles(nic,'jobOrder');
      console.log(res.data)
      if(res?.data?.length >0){
        setFiles(res.data);
      }else{
        setFiles([])
      }

    } catch (error) {
      alert("Error getting files");
    }
  };

  return (
  <ThemeProvider theme={theme}>
    <form onSubmit={handleSubmit}>

    <Grid container spacing={2}>
   

    <Grid item xs={12}>
      <Card style={{
        padding: 10,
      }}>
    <input             
        disabled={!(jobOrder.id)}
        type="file" onChange={handleFileChange} />
        <Button
        size='small'
        disabled={!(jobOrder.id)}
        onClick={() => uploadFile(file)}
        variant="contained" color="primary">
          Upload
        </Button>
        <FileCards files={files} />

    </Card>
    <FormGenerator formData={jobOrder} handleChange={handleChange} fields={fieldData} />
    </Grid>
    <HeightBox height={20} />
    <Grid item xs={12}>
    
    </Grid>
    <Grid item xs={12}>
       <div>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Se/No</TableCell>
            <TableCell>Job Category</TableCell>
            <TableCell>No of Vacancies</TableCell>
            <TableCell>Salary </TableCell>
            <TableCell>currency </TableCell>
            <TableCell>SLBFE Chargeable Amount </TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => (
            <TableRow key={index}>
              <TableCell>
                <TextField
                  size='small'
                  value={row.serialNumber}
                  onChange={(e) => handleChangeRows(index, 'serialNumber', e.target.value)}
                />
              </TableCell>
              <TableCell>
                <TextField
                  size='small'
                  value={row.jobCategory}
                  onChange={(e) => handleChangeRows(index, 'jobCategory', e.target.value)}
                />
              </TableCell>
              <TableCell>
                <TextField
                                  size='small'

                  value={row.vacancies}
                  onChange={(e) => handleChangeRows(index, 'vacancies', e.target.value)}
                />
              </TableCell>
              <TableCell>
                <TextField
                 size='small'
                  value={row.salary}
                  onChange={(e) => handleChangeRows(index, 'salary', e.target.value)}
                />
               
              </TableCell>
              <TableCell>
              <TextField
                  size='small'

                  value={jobOrder.currency}
                  onChange={(e) => handleChangeRows(index, 'currency', e.target.value)}
                />
              </TableCell>
              <TableCell>
              <TextField
                  size='small'

                  value={row.fee}
                  onChange={(e) => handleChangeRows(index, 'fee', e.target.value)}
                />
              </TableCell>
              <TableCell>
                <IconButton onClick={() => removeRow(index)}>
                  <RemoveIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <IconButton onClick={addRow}>
        <AddIcon />
      </IconButton>
    </div>
        </Grid>
        <Grid item xs={12}>
        <Button
          disabled={loading}
          type="submit" variant="contained" color="primary">
            {loading ? <CircularProgress size={24} /> : 'Update Job'}
        </Button>
        <Button onClick={handleOnClose} variant="contained" color="secondary">Close</Button>
        </Grid>
    </Grid>
    </form>
  </ThemeProvider>
  );
};

export default UpdateJobOrderForm;
